<template>
    <div class="relative">
        <!-- Notification Bell -->
        <button
                @click="showNotifications = !showNotifications"
                class="relative p-2 text-gray-600 hover:text-gray-800 transition-colors"
        >
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M15 17h5l-5 5v-5zM10.24 8.56a5.97 5.97 0 01-4.66-6.24M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span
                    v-if="unreadCount > 0"
                    class="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center"
            >
        {{ unreadCount }}
      </span>
        </button>

        <!-- Notifications Dropdown -->
        <div
                v-if="showNotifications"
                class="absolute right-0 mt-2 w-80 bg-white rounded-lg shadow-xl z-50 max-h-96 overflow-y-auto"
        >
            <div class="p-4 border-b border-gray-200">
                <h3 class="text-lg font-semibold">Notifications</h3>
            </div>

            <div v-if="notifications.length === 0" class="p-4 text-gray-500 text-center">
                Aucune notification
            </div>

            <div v-else class="divide-y divide-gray-100">
                <div
                        v-for="notification in sortedNotifications"
                        :key="notification.id"
                        class="p-4 hover:bg-gray-50 transition-colors"
                        :class="{ 'bg-blue-50': !notification.read }"
                >
                    <div class="flex justify-between items-start">
                        <p class="text-sm text-gray-800">{{ notification.message }}</p>
                        <button
                                @click="markAsRead(notification.id)"
                                class="text-gray-400 hover:text-gray-600 ml-2"
                        >
                            ×
                        </button>
                    </div>
                    <p class="text-xs text-gray-500 mt-1">
                        {{ formatTime(notification.timestamp) }}
                    </p>
                </div>
            </div>

            <div class="p-4 border-t border-gray-200">
                <button
                        @click="markAllAsRead"
                        class="w-full bg-gray-100 text-gray-700 py-2 px-4 rounded hover:bg-gray-200 transition-colors"
                >
                    Tout marquer comme lu
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters, mapActions } from 'vuex';

    export default {
        // eslint-disable-next-line vue/multi-word-component-names
        name: 'Notifications',
        data() {
            return {
                showNotifications: false
            };
        },
        computed: {
            ...mapState(['notifications']),
            ...mapGetters(['unreadNotifications']),
            unreadCount() {
                return this.unreadNotifications.length;
            },
            sortedNotifications() {
                return [...this.notifications].sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
            }
        },
        methods: {
            ...mapActions(['markNotificationRead']),
            markAsRead(notificationId) {
                this.markNotificationRead(notificationId);
            },
            markAllAsRead() {
                this.notifications.forEach(notification => {
                    if (!notification.read) {
                        this.markNotificationRead(notification.id);
                    }
                });
            },
            formatTime(timestamp) {
                const date = new Date(timestamp);
                const now = new Date();
                const diffMs = now - date;
                const diffMins = Math.floor(diffMs / 60000);
                const diffHours = Math.floor(diffMs / 3600000);

                if (diffMins < 1) return 'À l\'instant';
                if (diffMins < 60) return `Il y a ${diffMins} min`;
                if (diffHours < 24) return `Il y a ${diffHours} h`;

                return date.toLocaleDateString('fr-FR');
            }
        },
        mounted() {
            // Fermer les notifications en cliquant à l'extérieur
            document.addEventListener('click', (event) => {
                if (!this.$el.contains(event.target)) {
                    this.showNotifications = false;
                }
            });
        }
    };
</script>